import { GameLeaderboardHeaderProps } from './props';
import PlayerCount from './PlayerCount';
import Profit from './Profit';
import styles from './styles.module.scss';

export default function GameLeaderboardHeader({
  isLoading,
  count,
  round,
  shouldShowResult,
}: GameLeaderboardHeaderProps) {
  return (
    <div className={styles.container}>
      <PlayerCount
        count={count ?? 0}
        isLoading={isLoading}
        round={round}
        shouldShowResult={shouldShowResult}
      />
      <Profit
        isLoading={isLoading}
        round={round}
        shouldShowResult={shouldShowResult}
      />
    </div>
  );
}
